import React from 'react';
import { adminRoute } from '@/modules/administration/routes';
import { createRoute } from '@tanstack/react-router';

export const cpManagementRoute = createRoute({
  getParentRoute: () => adminRoute,
  path: 'charge-point-management',
  wrapInSuspense: true,
  component: React.lazy(async () => await import('@/app/routes/Admin/AdminChargePoints')),
});
